import { CourseFeedbackContent } from 'common/types/feedback'
import { AppState } from 'web/store'

export const getZoomoutFeedbackContent = () => (
  state: AppState
): CourseFeedbackContent | undefined => {
  return state.zoomout.external.feedbackData
}
